import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import COLORS from '@mlb/react-patterns/style/universal.color.ts';
import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';
import ButtonPattern from '@mlb/react-patterns/components/Button/button.tsx';

const SortButton = styled(ButtonPattern).attrs(props => ({
    iconName: 'sort',
    iconSize: 22,
    size: 'md',
    styleName: 'default',
    shape: 'hollow',
    additionalProps: {
        'aria-label': props.dictionary?.sort_by || 'Sort By',
    },
    handlers: {
        onClick: props.showSortModal,
    },
}))`
    border: 1px solid ${COLORS.mlbGrey2};
    ${IconWrapper} {
        vertical-align: middle;
        stroke: none;
    }
`;

SortButton.propTypes = {
    dictionary: PropTypes.object,
    showSortModal: PropTypes.func,
};

SortButton.defaultProps = {
    dictionary: {},
    showSortModal: _noop,
};

export default SortButton;
